import {
  minValue,
  maxLength,
  minLength,
  required,
} from "vuelidate/lib/validators"

export const VALOR_MAXIMO = 99999999999999.99

// Validador customizado que garante que o último valor será o PARAMETRO_MAXIMO
const ultimoDocMultiplicador = (value = []) => {
  if (value) {
    const lastRegra = value[value.length - 1]
    if (!lastRegra) return true

    return lastRegra.valor_final >= VALOR_MAXIMO
  }

  return true
}

export default {
  meta_minimo_individual: { required, minValue: minValue(0) },
  maximo_individual: { required, minValue: minValue(0) },
  meta_coletiva: { required, minValue: minValue(0) },
  pontos_cumprida_meta_coletiva: { required, minValue: minValue(0) },
  pontuacao_extraordinaria_inicio: { required, minValue: minValue(0) },
  maximo_extraordinaria: { required, minValue: minValue(0) },
  percentual_total_individual: { required, minValue: minValue(0) },
  percentual_total_coletivo: { required, minValue: minValue(0) },
  percentual_por_fracao_extraordinaria: { required, minValue: minValue(0) },
  fracao_extraordinaria: { required, minValue: minValue(0) },
  pontos_por_hora_servico_extra: { required, minValue: minValue(0) },
  pontos_local_fechado: { required, minValue: minValue(0) },
  pontos_perdidos_ao_reabrir_osm: { required, minValue: minValue(0) },
  pontos_perdidos_por_dia_atraso_encerrar_osm: {
    required,
    minValue: minValue(0),
  },
  meses_experiencia: { required, minValue: minValue(1) },
  pontos_minimo_experiencia: { required, minValue: minValue(0) },
  meses_calcular_media_afastamento: { required, minValue: minValue(1) },
  secretario: {
    required,
    minLength: minLength(5),
    maxLength: maxLength(255),
  },
  comissao: {
    required,
    length: { minValue: minValue(1) },
    $each: {
      nome: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(255),
      },
      matricula: { required, maxLength: maxLength(20) },
    },
  },
  usuarios_internos_ids: {},
  doc_multiplicadores: {
    ultimoDocMultiplicador,
    $each: {
      valor_inicial: { required },
      valor_final: { required },
      fator: { required, minValue: minValue(1) },
    },
  },
}
